// extracted by mini-css-extract-plugin
export default {"Arrow":"CarouselArrow_Arrow__kVTXR","RightArrow":"CarouselArrow_RightArrow__vA953","LeftArrow":"CarouselArrow_LeftArrow__AOFF-"};